import { injectable, inject } from 'inversify';

import { History } from '@vk-hr-tek/core/history';
import { RoleService } from '@vk-hr-tek/core/http';

import { SettingsCompanyFeedPostsRouter } from '../../../settings/types';
import { modules } from '../../modules';

@injectable()
export class SettingsCompanyFeedPostsRouterService implements SettingsCompanyFeedPostsRouter {
  constructor(
    @inject(History) private history: History,
    @inject(RoleService) private readonly role: RoleService,
  ) {}

  goToNewsDetail(id: string): void {
    this.history.push(`/${modules.general_news.basename}/${id}`);
  }

  goToPostDetail(
    communityId: string,
    communitySlug: string,
    postId: string,
  ): void {
    this.history.push(
      `/${modules.community.basename}/${communityId}/${communitySlug}/post/${postId}`,
    );
  }
}
